import i18n from '@/libs/i18n'

const checkNullUndefined = key => {
  if (typeof key === 'object' || key === undefined) {
    return (key?.title && key?.title[i18n.locale]) || i18n.messages[i18n.locale].references.not_indicated
  }
  return key
}

export default {
  GET_APARTMENT_MAIN_INFO(state) {
    const {
      title, apartment_type, rc_object, home_material, cadastral_number, construction_stage, street, number,
      construction_start_date, construction_end_date,
    } = state.single_apartment

    const obj = {
      title,
      apartment_type: checkNullUndefined(apartment_type),
      rc_object: rc_object.title,
      home_material: checkNullUndefined(home_material),
      cadastral_number,
      construction_stage: checkNullUndefined(construction_stage),
      address: `${street}, ${number}`,
      сonstruction_time: `${checkNullUndefined(construction_start_date)} - ${checkNullUndefined(construction_end_date)}`,
    }
    return obj
  },
  GET_ONE_APARTMENT(state) {
    const {
      apartment_type, rc_object, home_material, construction_stage, construction_type, badge, ...rest
    } = state.single_apartment
    return {
      apartment_type: apartment_type?.id,
      home_material: home_material?.id,
      construction_stage: construction_stage?.id,
      construction_type: construction_type.map(el => el.id),
      rc_object: rc_object?.id,
      badge: badge.map(el => el.id),
      ...rest,
    }
  },
  GET_APARTMENTS: state => state.apartments,
  GET_APARTMENTS_COUNT: state => state.apartments.count,
  GET_CHECKERBOARD_LAYOUT: state => state.checkerboard_layout,
  GET_FLATS_PLANNINGS_BY_APARTMENT: state => state.flat_plannings_by_apartment,
  GET_ROOMS_COUNT_BY_APARTMENT: state => state.rooms_count_by_apartment,
  GET_BADGES: state => state.badges.results,
}
